module.exports = __webpack_public_path__ + "media/offers/arrow-2-5b173280.svg";